export const getPosts = async () => {
  const response = await fetch(
    `${process.env.REACT_APP_BACKEND}/api/get-posts`
  );
  const result = await response.json();
  return result;
};
